import { MenuList, Popover } from '@mui/material';

import { SidebarChildLink } from '@app/components/sidebar/SidebarChildLink';
import { type GroupHeaderConfig } from '@app/components/sidebar/sidebarLinkConfig';
import { popoverPaperSx } from '@shared/theme/popoverStyles';

type Props = {
  link: GroupHeaderConfig;
  anchorEl: HTMLElement | null;
  onClose: () => void;
};

/**
 * Second-level navigation for the collapsed (mini variant) sidebar.
 * Opened by clicking the group icon, anchored to the icon's top-right
 * like a context menu, so the rail itself never has to expand.
 */
export const SidebarGroupPopover = ({ link, anchorEl, onClose }: Props) => {
  return (
    <Popover
      open={anchorEl != null}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{
        paper: {
          elevation: 8,
          sx: {
            ...popoverPaperSx,
            // anchored to the icon's right edge, which sits inside the rail;
            // 8px reach the rail border, the rest is the visible gap
            ml: '14px',
            // pull the paper up so the first link is vertically centered
            // on the clicked 40px icon button (9px padding + 1px item
            // margin - half the row-height difference)
            mt: '-6px',
            minWidth: 220,
            // slightly more breathing room vertically than the 8px the
            // items keep from the side edges
            py: '9px',
          },
        },
      }}
    >
      <MenuList disablePadding dense>
        {link.children
          .filter(child => child.visible)
          .map(child => (
            <SidebarChildLink
              key={child.key}
              link={child}
              variant="popover"
              onNavigate={onClose}
            />
          ))}
      </MenuList>
    </Popover>
  );
};
